import { type CountryCode } from 'libphonenumber-js';

// Map browser locale country codes to libphonenumber country codes
// This mapping includes all countries supported by libphonenumber-js
const LOCALE_TO_COUNTRY_CODE: Record<string, CountryCode> = {
  'US': 'US',
  'GB': 'GB',
  'DE': 'DE',
  'TR': 'TR',
  'FR': 'FR',
  'IT': 'IT',
  'ES': 'ES',
  'NL': 'NL',
  'BE': 'BE',
  'AT': 'AT',
  'CH': 'CH',
  'PL': 'PL',
  'SE': 'SE',
  'NO': 'NO',
  'DK': 'DK',
  'FI': 'FI',
  'GR': 'GR',
  'PT': 'PT',
  'IE': 'IE',
  'CZ': 'CZ',
  'HU': 'HU',
  'RO': 'RO',
  'BG': 'BG',
  'HR': 'HR',
  'SK': 'SK',
  'SI': 'SI',
  'LT': 'LT',
  'LV': 'LV',
  'EE': 'EE',
  'LU': 'LU',
  'MT': 'MT',
  'CY': 'CY',
  'CA': 'CA',
  'AU': 'AU',
  'NZ': 'NZ',
  'JP': 'JP',
  'CN': 'CN',
  'IN': 'IN',
  'BR': 'BR',
  'MX': 'MX',
  'AR': 'AR',
  'ZA': 'ZA',
  'KR': 'KR',
  'SG': 'SG',
  'MY': 'MY',
  'TH': 'TH',
  'ID': 'ID',
  'PH': 'PH',
  'VN': 'VN',
  'AE': 'AE',
  'SA': 'SA',
  'IL': 'IL',
  'EG': 'EG',
  'NG': 'NG',
  'KE': 'KE',
  'RU': 'RU',
  'UA': 'UA',
  'BY': 'BY',
  'KZ': 'KZ',
  'UZ': 'UZ',
  'PK': 'PK',
  'BD': 'BD',
  'LK': 'LK',
  'NP': 'NP',
  'MM': 'MM',
  'KH': 'KH',
  'LA': 'LA',
  'MN': 'MN',
  'GE': 'GE',
  'AM': 'AM',
  'AZ': 'AZ',
  'TM': 'TM',
  'TJ': 'TJ',
  'KG': 'KG',
  'AF': 'AF',
  'IR': 'IR',
  'IQ': 'IQ',
  'SY': 'SY',
  'JO': 'JO',
  'LB': 'LB',
  'YE': 'YE',
  'OM': 'OM',
  'KW': 'KW',
  'QA': 'QA',
  'BH': 'BH',
  'DZ': 'DZ',
  'MA': 'MA',
  'TN': 'TN',
  'LY': 'LY',
  'SD': 'SD',
  'ET': 'ET',
  'SO': 'SO',
  'DJ': 'DJ',
  'ER': 'ER',
  'UG': 'UG',
  'TZ': 'TZ',
  'RW': 'RW',
  'BI': 'BI',
  'CD': 'CD',
  'CG': 'CG',
  'CM': 'CM',
  'CF': 'CF',
  'TD': 'TD',
  'NE': 'NE',
  'ML': 'ML',
  'BF': 'BF',
  'SN': 'SN',
  'GM': 'GM',
  'GW': 'GW',
  'GN': 'GN',
  'SL': 'SL',
  'LR': 'LR',
  'CI': 'CI',
  'GH': 'GH',
  'TG': 'TG',
  'BJ': 'BJ',
  'AO': 'AO',
  'ZM': 'ZM',
  'ZW': 'ZW',
  'BW': 'BW',
  'NA': 'NA',
  'LS': 'LS',
  'SZ': 'SZ',
  'MW': 'MW',
  'MZ': 'MZ',
  'MG': 'MG',
  'MU': 'MU',
  'SC': 'SC',
  'KM': 'KM',
  'CV': 'CV',
  'ST': 'ST',
  'GQ': 'GQ',
  'GA': 'GA',
  'CO': 'CO',
  'VE': 'VE',
  'EC': 'EC',
  'PE': 'PE',
  'BO': 'BO',
  'PY': 'PY',
  'UY': 'UY',
  'CL': 'CL',
  'CR': 'CR',
  'PA': 'PA',
  'NI': 'NI',
  'HN': 'HN',
  'SV': 'SV',
  'GT': 'GT',
  'BZ': 'BZ',
  'JM': 'JM',
  'HT': 'HT',
  'DO': 'DO',
  'CU': 'CU',
  'TT': 'TT',
  'BB': 'BB',
  'GD': 'GD',
  'LC': 'LC',
  'VC': 'VC',
  'AG': 'AG',
  'BS': 'BS',
  'SR': 'SR',
  'GY': 'GY',
  'FK': 'FK',
  'GF': 'GF',
  'GP': 'GP',
  'MQ': 'MQ',
  'RE': 'RE',
  'YT': 'YT',
  'PM': 'PM',
  'BL': 'BL',
  'MF': 'MF',
  'AW': 'AW',
  'CW': 'CW',
  'SX': 'SX',
  'BQ': 'BQ',
  'TC': 'TC',
  'VG': 'VG',
  'VI': 'VI',
  'PR': 'PR',
  'AS': 'AS',
  'GU': 'GU',
  'MP': 'MP',
  'MH': 'MH',
  'FM': 'FM',
  'PW': 'PW',
  'KI': 'KI',
  'NR': 'NR',
  'TV': 'TV',
  'TO': 'TO',
  'WS': 'WS',
  'FJ': 'FJ',
  'VU': 'VU',
  'NC': 'NC',
  'PF': 'PF',
  'CK': 'CK',
  'NU': 'NU',
  'PN': 'PN' as CountryCode,
  'TK': 'TK',
  'WF': 'WF',
  'SB': 'SB',
  'PG': 'PG',
  'BN': 'BN',
  'TL': 'TL',
  'MO': 'MO',
  'HK': 'HK',
  'TW': 'TW',
  'KP': 'KP',
  'BT': 'BT',
  'MV': 'MV',
  'IO': 'IO',
  'CC': 'CC',
  'CX': 'CX',
  'NF': 'NF',
  'AQ': 'AQ' as CountryCode,
  'GS': 'GS' as CountryCode,
  'TF': 'TF' as CountryCode,
  'HM': 'HM' as CountryCode,
  'EH': 'EH',
  'PS': 'PS',
  'AD': 'AD',
  'LI': 'LI',
  'MC': 'MC',
  'SM': 'SM',
  'VA': 'VA',
  'GI': 'GI',
  'IM': 'IM',
  'JE': 'JE',
  'GG': 'GG',
  'FO': 'FO',
  'GL': 'GL',
  'SJ': 'SJ',
  'AX': 'AX',
  'IS': 'IS',
  'AL': 'AL',
  'BA': 'BA',
  'ME': 'ME',
  'MK': 'MK',
  'RS': 'RS',
  'XK': 'XK',
  'MD': 'MD',
};

// Timezone to country mapping (common timezones)
// This helps detect country when locale doesn't match physical location
const TIMEZONE_TO_COUNTRY: Record<string, CountryCode> = {
  'Europe/Istanbul': 'TR',
  'Europe/Berlin': 'DE',
  'Europe/London': 'GB',
  'Europe/Paris': 'FR',
  'Europe/Rome': 'IT',
  'Europe/Madrid': 'ES',
  'Europe/Amsterdam': 'NL',
  'Europe/Brussels': 'BE',
  'Europe/Vienna': 'AT',
  'Europe/Zurich': 'CH',
  'Europe/Warsaw': 'PL',
  'Europe/Stockholm': 'SE',
  'Europe/Oslo': 'NO',
  'Europe/Copenhagen': 'DK',
  'Europe/Helsinki': 'FI',
  'Europe/Athens': 'GR',
  'Europe/Lisbon': 'PT',
  'Europe/Dublin': 'IE',
  'Europe/Prague': 'CZ',
  'Europe/Budapest': 'HU',
  'Europe/Bucharest': 'RO',
  'Europe/Sofia': 'BG',
  'Europe/Zagreb': 'HR',
  'Europe/Bratislava': 'SK',
  'Europe/Ljubljana': 'SI',
  'Europe/Vilnius': 'LT',
  'Europe/Riga': 'LV',
  'Europe/Tallinn': 'EE',
  'Europe/Luxembourg': 'LU',
  'Europe/Valletta': 'MT',
  'Europe/Nicosia': 'CY',
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'America/Phoenix': 'US',
  'America/Anchorage': 'US',
  'America/Honolulu': 'US',
  'America/Toronto': 'CA',
  'America/Vancouver': 'CA',
  'America/Mexico_City': 'MX',
  'America/Sao_Paulo': 'BR',
  'America/Buenos_Aires': 'AR',
  'America/Santiago': 'CL',
  'America/Bogota': 'CO',
  'America/Lima': 'PE',
  'America/Caracas': 'VE',
  'America/La_Paz': 'BO',
  'America/Asuncion': 'PY',
  'America/Montevideo': 'UY',
  'Asia/Dubai': 'AE',
  'Asia/Riyadh': 'SA',
  'Asia/Jerusalem': 'IL',
  'Asia/Tokyo': 'JP',
  'Asia/Shanghai': 'CN',
  'Asia/Hong_Kong': 'HK',
  'Asia/Taipei': 'TW',
  'Asia/Seoul': 'KR',
  'Asia/Singapore': 'SG',
  'Asia/Kuala_Lumpur': 'MY',
  'Asia/Bangkok': 'TH',
  'Asia/Jakarta': 'ID',
  'Asia/Manila': 'PH',
  'Asia/Ho_Chi_Minh': 'VN',
  'Asia/Dhaka': 'BD',
  'Asia/Kolkata': 'IN',
  'Asia/Karachi': 'PK',
  'Asia/Colombo': 'LK',
  'Asia/Kathmandu': 'NP',
  'Asia/Yangon': 'MM',
  'Asia/Tehran': 'IR',
  'Asia/Baghdad': 'IQ',
  'Asia/Damascus': 'SY',
  'Asia/Amman': 'JO',
  'Asia/Beirut': 'LB',
  'Asia/Aden': 'YE',
  'Asia/Muscat': 'OM',
  'Asia/Kuwait': 'KW',
  'Asia/Qatar': 'QA',
  'Asia/Bahrain': 'BH',
  'Africa/Cairo': 'EG',
  'Africa/Johannesburg': 'ZA',
  'Africa/Lagos': 'NG',
  'Africa/Nairobi': 'KE',
  'Australia/Sydney': 'AU',
  'Australia/Melbourne': 'AU',
  'Australia/Brisbane': 'AU',
  'Australia/Perth': 'AU',
  'Pacific/Auckland': 'NZ',
  'Europe/Moscow': 'RU',
  'Europe/Kiev': 'UA',
  'Europe/Minsk': 'BY',
  'Asia/Almaty': 'KZ',
  'Asia/Tashkent': 'UZ',
  'Asia/Baku': 'AZ',
  'Asia/Tbilisi': 'GE',
  'Asia/Yerevan': 'AM',
};

// Cache for IP-based country detection
let cachedCountry: CountryCode | null = null;
let countryDetectionPromise: Promise<CountryCode | undefined> | null = null;

/**
 * Detect country from IP address using free geolocation service
 * Uses ipapi.co (free, no API key required for basic usage)
 * Results are cached to avoid repeated API calls
 */
async function detectCountryFromIP(): Promise<CountryCode | undefined> {
  // Return cached result if available
  if (cachedCountry) {
    return cachedCountry;
  }

  // If detection is already in progress, return the existing promise
  if (countryDetectionPromise) {
    return countryDetectionPromise;
  }

  // Start new detection
  countryDetectionPromise = (async () => {
    try {
      // Create AbortController for timeout (more compatible than AbortSignal.timeout)
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3000);

      // Using ipapi.co (free, no API key required for basic usage)
      // Alternative services: ip-api.com, ipinfo.io
      const response = await fetch('https://ipapi.co/json/', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error('IP geolocation failed');
      }

      const data = await response.json();
      const countryCode = data.country_code as string;

      if (countryCode && LOCALE_TO_COUNTRY_CODE[countryCode]) {
        cachedCountry = LOCALE_TO_COUNTRY_CODE[countryCode] as CountryCode;
        return cachedCountry;
      }
    } catch (error) {
      // Silently fail - we have fallbacks
      // Only log in development
      if (process.env.NODE_ENV === 'development') {
        console.debug('IP geolocation failed, using fallback:', error);
      }
    }

    return undefined;
  })();

  return countryDetectionPromise;
}

/**
 * Detect country from timezone
 * Useful when locale doesn't match physical location (e.g., en-US user in Turkey)
 */
function detectCountryFromTimezone(): CountryCode | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return TIMEZONE_TO_COUNTRY[timezone];
  } catch {
    return undefined;
  }
}

/**
 * Detect user's country from browser locale
 * Returns a libphonenumber CountryCode or undefined if not detected
 */
function detectUserCountryFromLocale(): CountryCode | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    // Try Intl API first (more accurate)
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const parts = locale.split('-');
    const countryCode = parts.length > 1 ? parts[1] : parts[0].toUpperCase();
    
    if (LOCALE_TO_COUNTRY_CODE[countryCode]) {
      return LOCALE_TO_COUNTRY_CODE[countryCode] as CountryCode;
    }
  } catch {
    // Fallback to navigator.language
  }

  // Fallback to navigator.language
  if (navigator.language) {
    const parts = navigator.language.split('-');
    const countryCode = parts.length > 1 ? parts[1] : parts[0].toUpperCase();
    return LOCALE_TO_COUNTRY_CODE[countryCode] as CountryCode | undefined;
  }

  return undefined;
}

/**
 * Get default country for phone input (synchronous, fast)
 * Uses timezone and locale as immediate fallbacks
 * Priority: Timezone > Locale > Default (DE)
 * 
 * This is fast and doesn't require async operations, making it ideal
 * for initial component rendering.
 * 
 * Wrapped in try-catch to ensure it never throws and blocks the app.
 */
export function getDefaultCountry(): CountryCode {
  try {
    // Try timezone first (fast, no async needed, more accurate for physical location)
    const timezoneCountry = detectCountryFromTimezone();
    if (timezoneCountry) {
      return timezoneCountry;
    }

    // Try locale (browser language setting)
    const localeCountry = detectUserCountryFromLocale();
    if (localeCountry) {
      return localeCountry;
    }
  } catch (error) {
    // Silently fail - always return a default
    if (process.env.NODE_ENV === 'development') {
      console.debug('Country detection error, using default:', error);
    }
  }

  // Default fallback
  return 'DE';
}

/**
 * Get default country with IP detection (async, most accurate)
 * Priority: IP Geolocation > Timezone > Locale > Default (DE)
 * 
 * Use this when you can wait for the async result and want the most
 * accurate country detection based on physical location.
 * 
 * Results are cached, so subsequent calls return immediately.
 */
export async function getDefaultCountryAsync(): Promise<CountryCode> {
  // Try IP geolocation first (most accurate for physical location)
  const ipCountry = await detectCountryFromIP();
  if (ipCountry) {
    return ipCountry;
  }

  // Fallback to synchronous methods
  return getDefaultCountry();
}

/**
 * Detect user's country from browser locale (legacy function, kept for compatibility)
 * @deprecated Use getDefaultCountry() or getDefaultCountryAsync() instead
 */
export function detectUserCountry(): CountryCode | undefined {
  return detectUserCountryFromLocale();
}

